import { KEYBOARD_KEYS } from '../../../constants';

export const isRightKey = (key: string, separator: string) => {
  return key === separator || key === KEYBOARD_KEYS.ENTER;
};
